<!--package view;-->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="考勤小组名称">
              <a-input placeholder="请输入考勤小组名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="$refs.attendGroupAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
        v-action="'sys:attend:group-form:add'"
      >新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
    <attendGroup-add-or-update
      @ok="queryPage"
      ref="attendGroupAddOrUpdate"
    />
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchListPro, delObj } from '@/api/common/AttendGroup'
import attendGroupAddOrUpdate from './AttendGroupAddOrUpdate'
import { enterEvent } from '@/utils/util'
export default {
  name: 'AttendGroupView',
  mixins: [TableMixin],
  components: {
    attendGroupAddOrUpdate
  },
  data () {
    return {
      description: '创建管理项目考勤小组，并分配考勤员',
      queryParam: {
        test: ''
      },
      loadData: parameter => {
        return fetchListPro(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '100px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        // {
        //   title: '主键',
        //   dataIndex: 'id'
        // },
        {
          title: '考勤小组名称',
          dataIndex: 'name'
        },
        {
          title: '考勤员',
          dataIndex: 'leaderIdName'
        },
        {
          title: '项目',
          dataIndex: 'projectIdName'
        },
        {
          title: '操作',
          width: '200px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="sys:attend:group-form:show">
                  <a onClick={(e) => this.show(record)}>查看</a>
                </span>
                <span v-action="sys:attend:group-form:edit">
                  <a-divider type="vertical" />
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
                <span v-action="sys:attend:group-form:del">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否删除部门" onConfirm={() => this.deleteItem(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">删除</a>
                  </a-popconfirm>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$refs.attendGroupAddOrUpdate.init(record.id, 'show')
    },
    edit (record) {
      this.$refs.attendGroupAddOrUpdate.init(record.id, 'edit')
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    }
  },
  created () {
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
